/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity, TextInput } from 'react-native';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import SelectBox from '@components/form/SelectBox';
import { selectParams } from '@/store/params';
import { translate } from '@global/translate';
import { useTranslationDisabled } from '@components/shared/TranslationContext';

const SearchTable = (props) => {
  const translationDisabled = useTranslationDisabled();
  const testID = props.testID || 'search-table';
  const filterName = props.filterName ? props.filterName : null;
  const paramsState = useSelector(selectParams(filterName)); // existing active parameters
  const searchKey = props.searchKey ? props.searchKey : null; // search key for filter
  const searchForOptions = props.searchForOptions
    ? props.searchForOptions
    : false; // enable search for feature B2B-3696

  const [keyword, setKeyword] = useState(props.value || '');
  const [searchForValue, setSearchForValue] = useState(props.valueFor);

  // search callback
  const doSearch = () => {
    try {
      props.onSearch(keyword, searchForValue);
    } catch (error) {}
  };

  // reset keyword when changing page
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (Array.isArray(searchKey)) {
        // multi-field search lives in filter.$or — derive the keyword from it
        const orArr = paramsState?.filter?.$or;
        const field = searchKey[0];
        const entry = Array.isArray(orArr)
          ? orArr.find((f) => f?.[field]?.$regex != null)
          : null;
        setKeyword(entry ? entry[field].$regex : '');
      } else if (searchKey && paramsState?.filter[searchKey]) {
        if (paramsState?.filter[searchKey]?.$regex) {
          setKeyword(paramsState.filter[searchKey].$regex);
        } else {
          setKeyword(paramsState.filter[searchKey]);
        }
      } else if (searchKey) {
        setKeyword('');
      }
    }
    return () => {
      mounted = false;
    };
  }, [paramsState]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (props.value) {
        setKeyword(props.value);
      } else {
        setKeyword('');
      }
    }
    return () => {
      mounted = false;
    };
  }, [props.value]);

  return (
    <View
      testID={testID}
      style={[styles.search, { width: props.width ? props.width : 300 }]}>
      <TextInput
        testID={`${testID}-input`}
        label=""
        value={keyword || keyword == 0 ? keyword.toString() : ''}
        placeholder={
          translationDisabled
            ? props.searchPlaceholder
            : translate(props.searchPlaceholder)
        }
        style={[
          styles.searchInput,
          props.withBorder ? { borderColor: Colors.grey0 } : {},
        ]}
        onChangeText={(value) => setKeyword(value)}
        onSubmitEditing={doSearch}
      />
      {Array.isArray(searchForOptions) && searchForOptions.length > 1 && (
        <SelectBox
          testID={`${testID}-select`}
          isDropdown
          label={'Search For'}
          hideLabel
          options={searchForOptions}
          placeholder="Search For"
          trackBy="value"
          labelKey="label"
          formLabelKey="label"
          value={searchForValue}
          onChange={(value) => setSearchForValue(value)}
          style={{ width: 210 }}
        />
      )}
      <TouchableOpacity
        testID={`${testID}-btn`}
        activeOpacity={0.6}
        style={styles.searchBtn}
        onPress={() => doSearch()}>
        <SociollaText type="medium" style={styles.searchBtnText}>
          Search
        </SociollaText>
        <Image
          style={{ width: 12, height: 12 }}
          width={12}
          height={12}
          svg={true}
          source={require('@assets/img/icons/search-white.svg')}
        />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  search: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
  },
  searchInput: {
    width: '100%',
    height: 36,
    fontSize: 12,
    fontFamily: 'figtree-regular',
    paddingLeft: 10,
    paddingRight: 10,
    backgroundColor: Colors.white,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    borderWidth: 1,
    borderColor: Colors.white,
  },
  searchBtn: {
    height: 36,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    backgroundColor: Colors.blue3,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
  },
  searchBtnText: {
    fontSize: 14,
    marginRight: 10,
    color: Colors.white,
  },
});

export default React.memo(SearchTable, (prev, next) => prev == next);
